import type { ComponentType } from 'react';
import PickerToolbarImport from '@material-ui/pickers/_shared/PickerToolbar';
import ToolbarButtonImport from '@material-ui/pickers/_shared/ToolbarButton';

const unwrapDefault = <T>(module: T): T => {
  const value = module as any;
  return (value?.default?.default ?? value?.default ?? value) as T;
};

export const PickerToolbar = unwrapDefault<ComponentType<any>>(PickerToolbarImport as any);
export const ToolbarButton = unwrapDefault<ComponentType<any>>(ToolbarButtonImport as any);
